export default __webpack_public_path__ + "static/media/Vestadmyr1.19307c8b.jpg";